import { Accordion } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { AdditionalContact } from './AdditionalContact';
import './AdditionalContactSection.scss';

const AdditionalContactSectionImpl: React.FC = () => {
  const {
    nominationWizardPageUiStore,
  } = useStores();

  return (
    <div
      className='additional-contact-section'
    >
      <Accordion<string>
        collapsible
        multiple
        openItems={nominationWizardPageUiStore.expandedContactKeys}
        onToggle={(_, data) => {
          if (!data.openItems.includes((data.value))) {
            nominationWizardPageUiStore.collapseContact(data.value);
          } else {
            nominationWizardPageUiStore.expandContact(data.value);
          }
        }}
      >
        {
          nominationWizardPageUiStore.nomination.contacts.map((contact, index) => {
            const rowKey = nominationWizardPageUiStore.contactRowKeys[index];

            return (
              <AdditionalContact
                key={rowKey}
                rowKey={rowKey}
                contactIndex={index}
                onRemoveContact={() => nominationWizardPageUiStore.removeContact(index)}
                contact={contact}
                isFirstContact={index === 0}
              />);
          })
        }
      </Accordion>
    </div>
  );
}

export const AdditionalContactSection = observer(AdditionalContactSectionImpl);
